document.addEventListener('DOMContentLoaded', function () {
  var arrowsDown = document.getElementsByClassName('arrow-down') || []
  var mainRegion = document.querySelector('.landing-page__content')

  if (!mainRegion) return

  for (var arrow of arrowsDown) {
    arrow.addEventListener('click', function (event) {
      mainRegion.scrollIntoView({ behavior: 'smooth' })
    })
  }

  const bannerIngress = document.querySelector('.banner-with-ingress')
  const landingContent = document.querySelector('.landing-page__content')

  if (!landingContent) return

  const intro = landingContent.querySelector('.intro')

  if (intro && bannerIngress) {
    bannerIngress.style['margin-bottom'] = '0'
  }
})
